import React, {useContext, useEffect, useRef} from 'react';
import {Button, Typography} from '@material-ui/core';
import {ThemeContext} from '../../../themes/ThemeProvider';
import ContactsTable from './ContactsTable';
import AddressTable from './AddressTable';
import PhoneTable from './PhoneTable';
import NotesTable from './NotesTable';
import {ArrowBack} from '@material-ui/icons';
import {backButtonText} from '../../../util/Content';
import {useDispatch} from 'react-redux';
import {fetchDropDowns} from '../../../redux/reducers/clientMangement/Organizaation';
import RenderForm from './RenderForm';
import {setAlertData} from '../../../redux/reducers/UnsavedChangesAlertReducer';
import {TENANTS_REVONE_COMPANIES} from '../../../constants/ReusableConstants';
import useUnsavedChangesWarning from '../../../util/CustomHooks';

function index({
  setTabValue = () => {},
  edit,
  setEdit,
  orgType,
  id,
  siteTableData,
  organizationAccess,
}) {
  const {onDirty, onPristine} = useUnsavedChangesWarning();
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const dispatch = useDispatch();
  const showAlertRef = useRef(false);
  const changeDirty = useRef(true);
  const handleDirty = (dirty, isFixed) => {
    if (isFixed === 'fixed') {
      showAlertRef.current = dirty;
      changeDirty.current = false;
      if (dirty) {
        onDirty();
      } else {
        onPristine();
      }
    }
    if (isFixed === 'reset') {
      showAlertRef.current = false;
      changeDirty.current = true;
      onPristine();
    }
    if (changeDirty.current) {
      showAlertRef.current = dirty;
      if (dirty) {
        onDirty();
      } else {
        onPristine();
      }
    }
  };
  const alertProps = {
    showAlertRef,
    handleDirty,
  };
  useEffect(() => {
    dispatch(fetchDropDowns());
  }, []);

  return (
    <div>
      <div className="button-table-spacing-mb justify-content-between new-standard-textfields">
        <Button
          variant="outlined"
          type="button"
          className={`search-btn ${classes.buttonRoot}`}
          onClick={() => {
            if (showAlertRef.current) {
              dispatch(
                setAlertData({
                  showAlert: showAlertRef.current,
                  alertCallback: () => {
                    setTabValue(0);
                  },
                }),
              );
            } else {
              setTabValue(0);
            }
          }}
        >
          <ArrowBack className="mr-2" />
          {backButtonText}
        </Button>
      </div>
      <div>
        <div className="mx-2 my-4 org-title">
          <Typography>
            {`${orgType === 'Company' ?
              TENANTS_REVONE_COMPANIES :
              orgType === 'Service-Client' ?
                'Department' :
                orgType || ''} Information`}
          </Typography>
        </div>
        <RenderForm
          orgType={orgType?.toLowerCase()}
          siteTableData={siteTableData}
          organizationAccess={organizationAccess}
          edit={edit}
          {...alertProps}
        />
      </div>
      <NotesTable
        orgType={orgType}
        id={id}
        {...alertProps}
        organizationAccess={organizationAccess}
      />
      <ContactsTable
        orgType={orgType}
        id={id}
        {...alertProps}
        organizationAccess={organizationAccess}
      />
      <PhoneTable
        orgType={orgType}
        id={id}
        {...alertProps}
        organizationAccess={organizationAccess}
      />
      <AddressTable
        orgType={orgType}
        id={id}
        {...alertProps}
        organizationAccess={organizationAccess}
      />
    </div>
  );
}

export default index;
